import { defineCatalogue } from '../../../i18n';
import { messages as en } from './en';
import { messages as pt } from './pt-BR';

export type CampaignMessageKey = keyof typeof pt;

const catalogue = defineCatalogue(pt, en);

export function t(key: CampaignMessageKey, vars?: Record<string, string | number>): string {
  return catalogue.t(key, vars);
}

export function plural(
  key: CampaignMessageKey,
  count: number,
  vars?: Record<string, string | number>,
): string {
  return catalogue.plural(key, count, vars);
}
